import Cookies from 'universal-cookie';
import { getConfig } from '@/config';

let instance: Cookies | null = null;

export default function useCookies() {
    if (!instance) {
        const domain = getConfig().cookieDomain || undefined;

        instance = new Cookies(null, {
            domain,
            maxAge: 3 * 365 * 24 * 60 * 60,
            path:   '/',
            secure: true,
        });
    }

    return instance;
}
